export { PartNumberModalComponent } from './partnumber-modal/partnumber-modal.component';
export { PartNumberTableComponent } from './partnumber-table/partnumber-table.component';
